/**
 * UTM fissi sui link verso satur.it. Valori dati dal responsabile e-commerce di
 * satur.it (stessa convenzione di Kooper, 13/08/2026): non variano per pagina,
 * per prodotto o per canale. "refferal" e' scritto cosi' nel messaggio
 * originale: non correggerlo, il suo Analytics filtra sulla stringa esatta.
 */
const UTM = {
  utm_source: 'vdesite',
  utm_medium: 'organic',
  utm_campaign: 'vdewebsite',
  utm_content: 'refferal',
};

/** Vero per qualunque host satur.it (www compreso). */
export const isSatur = (url) => /^https?:\/\/([^/]+\.)?satur\.it(\/|$)/i.test(url || '');

/** Aggiunge i quattro UTM a un link verso satur.it; su altri host non tocca nulla. */
export function withUtm(url) {
  if (!url) return url;
  let u;
  try {
    u = new URL(url);
  } catch (e) {
    return url;
  }
  if (!isSatur(u.href)) return url;
  Object.entries(UTM).forEach(([k, v]) => u.searchParams.set(k, v));
  return u.toString();
}
